import React, { useEffect } from 'react';
import SoftSkill from './SoftSkill';
import Aos from 'aos';

const Skill = () => {
  // aos initialization
  useEffect(() => {
    Aos.init({
      duration: 2000,
    });
  }, []);

  return (
    <section id="skill" className="container mx-auto mt-2 md:mt-0">
      <div className="flex justify-center relative">
        <h2 className="text-white font-extrabold text-4xl z-20">MY SKILLS.</h2>
        <svg
          className="absolute mt-[20px]"
          width="175"
          height="30"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5 20 Q 70 0 150 20"
            stroke="#E12457"
            fill="transparent"
            strokeWidth="7"
            strokeLinecap="round"
          />
        </svg>
      </div>

      <div className="py-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 px-5">
          {/* Left Side: Technical Skill */}
          <div>
            {/* Header Row */}
            <div className="flex items-center gap-10 mb-5">
              <div className="relative">
                <h2 className="text-white font-bold text-2xl">
                  Technical Skill
                </h2>
                <div className="h-[0.5px] bg-white  mt-1 rounded-full w-full md:w-[250%]"></div>
              </div>
            </div>

            {/* Technical skill bars */}
            <div data-aos="fade-up-right" className="mt-5">
              <div>
                <p className="text-white mb-2">JavaScript</p>
                <div className="h-2 bg-white rounded-full">
                  <div
                    className="h-full bg-primary rounded-full"
                    style={{ width: '80%' }}
                  ></div>
                </div>
              </div>
              <div>
                <p className="text-white mb-2">Go (GoLang)</p>
                <div className="h-2 bg-white rounded-full">
                  <div
                    className="h-full bg-primary rounded-full"
                    style={{ width: '75%' }}
                  ></div>
                </div>
              </div>
              <div>
                <p className="text-white mb-2">React</p>
                <div className="h-2 bg-white rounded-full">
                  <div
                    className="h-full bg-primary rounded-full"
                    style={{ width: '80%' }}
                  ></div>
                </div>
              </div>
              <div>
                <p className="text-white mb-2">React Native</p>
                <div className="h-2 bg-white rounded-full">
                  <div
                    className="h-full bg-primary rounded-full"
                    style={{ width: '85%' }}
                  ></div>
                </div>
              </div>
              <div>
                <p className="text-white mb-2">React Router</p>
                <div className="h-2 bg-white rounded-full">
                  <div
                    className="h-full bg-primary rounded-full"
                    style={{ width: '90%' }}
                  ></div>
                </div>
              </div>
              <div>
                <p className="text-white mb-2">Express.js</p>
                <div className="h-2 bg-white rounded-full">
                  <div
                    className="h-full bg-primary rounded-full"
                    style={{ width: '65%' }}
                  ></div>
                </div>
              </div>
              <div>
                <p className="text-white mb-2">Node.js</p>
                <div className="h-2 bg-white rounded-full">
                  <div
                    className="h-full bg-primary rounded-full"
                    style={{ width: '75%' }}
                  ></div>
                </div>
              </div>
              <div>
                <p className="text-white mb-2">MongoDb</p>
                <div className="h-2 bg-white rounded-full">
                  <div
                    className="h-full bg-primary rounded-full"
                    style={{ width: '80%' }}
                  ></div>
                </div>
              </div>
            </div>
          </div>

          {/* Right Side: Soft Skill */}
          <div>
            <h2 className="text-white font-bold text-2xl relative mt-16 md:mt-[1px]">
              Soft Skill
            </h2>
            <div className="h-[0.5px] bg-white w-full mt-1 rounded-full"></div>
            <div className="flex justify-start items-center mt-10 md:mt-0">
              <div
                data-aos="fade-up-left"
                className="flex flex-col md:flex-row justify-start gap-5 items-center mt-5 md:mt-20"
              >
                <SoftSkill percentage={85} text="Team Work" />
                <SoftSkill percentage={80} text="Leadership" />
                <SoftSkill percentage={90} text="Creativity" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skill;
